import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { useContext } from "react";
import api from "@beeldit/core/helpers/api";
import { EntryTimeContext } from "../contexts/EntryTimeContext";

function useGet() {
  const { setElement, setShowModal } = useContext(EntryTimeContext);
  const errorHandler = useErrorHandler();
  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    api
      .get(`/entry_times/${id}`)
      .then((response) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setShowModal(true);
      })
      .catch((error) => {
        errorHandler(error);
      });
  };
}

export default useGet;
